module.exports = __webpack_public_path__ + "static/dl1_og-image-74b5c337031d46532682243b1aa48511.jpg";